export default "https://cdn-static.gokick.com/assets/46c46890c219de5164704b27b734f3ae915944d1/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";